import { Hero } from "@/components/site/Hero";
import { About, Services, Gallery } from "@/components/site/Sections1";
import { Testimonials, Instagram, Blog, FAQ } from "@/components/site/Sections2";
import { Events } from "@/components/site/Events";
import { Extras, Contact, Footer } from "@/components/site/Contact";

export default function Home() {
  return (
    <main>
      <Hero />
      <About />
      <Services />
      <Events />
      <Gallery />
      <Testimonials />
      <Instagram />
      <Extras />
      <Blog />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}
